import moment from 'moment';
import React from 'react';

import {
  CalendarEntriesByDate,
  CalendarFilesByDate,
  CalendarRequestsByDate,
  CalendarProcessTasksByDate,
} from 'calendar/CalendarConstants';
import DataConnector from 'connect/DataConnector';
import navigateToURL from 'lib/navigateToURL';
import * as FullScreenActions from 'nav/full-screen/FullScreenActions';
import Modal from 'ui-library/modals/Modal';
import * as DateUtil from 'util/DateUtil';

import CalendarStore from './CalendarStore';
import DailyFileActivity from './DailyFileActivity';
import DailyProjectActivity from './DailyProjectActivity';

class CalendarItemModalConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [CalendarStore];

  enhanceProps(): EnhancedProps {
    return {
      isLoadingData: this.calendarStore().isLoadingData(),
      entries: this.calendarStore().getEntries(),
      files: this.calendarStore().getNonEntryFiles(),
      requests: this.calendarStore().getRequests(),
      processTasks: this.calendarStore().getProcessTasks(),
    };
  }
}

interface Props {
  date: moment.Moment;
  item: {
    id: string;
    name: string;
    url: string;
  };
  onRequestClose: () => void;
}

interface EnhancedProps {
  isLoadingData: boolean;
  entries: CalendarEntriesByDate;
  files: CalendarFilesByDate;
  requests: CalendarRequestsByDate;
  processTasks: CalendarProcessTasksByDate;
}

class CalendarItemModal extends React.Component<Props & EnhancedProps> {
  _handleItemClick = (): void => {
    FullScreenActions.hideScreen();
    navigateToURL(this.props.item.url);
  };

  override render(): JSX.Element {
    const dateKey = this.props.date.format('YYYY-MM-DD');

    const entries = (this.props.entries[dateKey] ?? []).filter(
      (entry) => entry.source.id === this.props.item.id
    );

    const requests = (this.props.requests[dateKey] ?? []).filter(
      (request) => request.projectId === this.props.item.id
    );

    const files = (this.props.files[dateKey] ?? []).filter(
      (file) => file.source && file.source.id === this.props.item.id
    );

    const processTasks = (this.props.processTasks[dateKey] ?? []).filter(
      (task) => task.process.folder.source.id === this.props.item.id
    );

    const title = (
      <div>
        <a className="calendarItemModal-name" onClick={this._handleItemClick}>
          {this.props.item.name}
        </a>
        <div className="calendarItemModal-date">
          {DateUtil.readableTime(this.props.date, {showTime: false})}
        </div>
      </div>
    );

    return (
      <Modal title={title} onRequestClose={this.props.onRequestClose}>
        <DailyProjectActivity
          requests={requests}
          entries={entries}
          processTasks={processTasks}
          date={this.props.date}
          isLoadingData={this.props.isLoadingData}
        />
        <DailyFileActivity
          className="dailyFileActivity--dayView dailyFileActivity--modal"
          compact={false}
          files={files}
        />
      </Modal>
    );
  }
}

export default CalendarItemModalConnector.connect(CalendarItemModal);
